import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { saveLoginInfo } from "../../../../features/mobile/commonSlice";
import { regMobile } from "../../components/logic";
import api from "../../../../common/api";
import HeadCont from "../../components/common/HeadCont";
import InputBox from "../../components/common/InputBox";
import TitleBox from "../../components/common/TitleBox";
import Btn from "../../components/common/Btn";
import Dialog from "../../components/common/Dialog";

const SignIn = () => {
  const { t } = useTranslation('auth');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [loginDatas, setLoginDatas] = useState({ email: "", pass: "", token: "" });
  const [active1, setActive1] = useState("default");
  const [active2, setActive2] = useState("default");
  const [errorMsg, setErrorMsg] = useState({ msg1: "", msg2: "" });
  const [openDialog, setOpenDialog] = useState(false);
  const emailRef = useRef(null);
  const passRef = useRef(null);

  const onChangeInput1 = (e) => {
    setLoginDatas({ ...loginDatas, email: e.target.value });

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(e.target.value)) {
      setActive1("on");
      setErrorMsg({ ...errorMsg, msg1: "" });
    } else if (e.target.value.length > 0) {
      setActive1("ready");
    } else {
      setActive1("default");
    }
  };

  const onChangeInput2 = (e) => {
    setLoginDatas({ ...loginDatas, pass: e.target.value });

    if (e.target.value?.length >= 1) setActive2("on");
    // else setActive2("ready");
  };

  const onDeleteValue = (type) => {
    if (type === "email") {
      setLoginDatas({ ...loginDatas, email: "" });
      setErrorMsg({ ...errorMsg, msg1: "" });
      setActive1("default");
      emailRef.current?.focus();
    } else {
      setLoginDatas({ ...loginDatas, pass: "" });
      setErrorMsg({ ...errorMsg, msg2: "" });
      setActive2("default");
      passRef.current?.focus();
    }
  };

  const onLogin = async (e) => {
    e.preventDefault();
    const sessionToken = window.sessionStorage.getItem("token");
    if (active1 === "on" && active2 === "on") {
      let params = {
        email: loginDatas.email,
        password: loginDatas.pass,
        firebaseToken: sessionToken,
      };
      const res = await api.post(`/auth/email/login`, params);
      try {
        console.log(res);
        if (res.data.ok) {
          // Store JWT token
          localStorage.setItem('accessToken', res.data.accessToken);

          // Check if registration is incomplete
          if (res.data.registrationStep && res.data.registrationStep !== 'completed') {
            // Store user data in sessionStorage to continue signup
            sessionStorage.setItem('incompleteRegistration', JSON.stringify({
              email: loginDatas.email,
              userId: res.data.userId,
              nickName: res.data.nickName,
              registrationStep: res.data.registrationStep
            }));

            // Redirect to signup page to continue from where they left off
            // registrationStep values:
            // 'email_verified' → step 2 (password setup)
            // 'terms_agreed' → step 5 (nickname/character)
            let resumeStep = 5; // default to nickname step
            if (res.data.registrationStep === 'email_verified') {
              resumeStep = 2; // password setup step
            }

            navigate('/emailsignup', {
              state: {
                continueRegistration: true,
                email: loginDatas.email,
                userId: res.data.userId,
                step: resumeStep
              }
            });
            return;
          }

          setOpenDialog(true);
          const main = document.querySelector(".main");
          main.style.overflow = "hidden";
          main.style.width = "100%";
          dispatch(saveLoginInfo({ ...res.data, existPass: true }));
          setLoginDatas({ email: "", pass: "", token: "" });
          emailRef.current.value = "";
          passRef.current.value = "";
        } else {
          setErrorMsg({ ...errorMsg, msg2: res.data.error });
          setLoginDatas({ email: "", pass: "", token: "" });
          setActive2("");
          emailRef.current.focus();
          emailRef.current.value = "";
          passRef.current.value = "";
        }
      } catch (err) {
        console.log(err);
        setErrorMsg({ ...errorMsg, msg2: t('login.error_occurred') });
      }
    }
  };

  useEffect(() => {
    let focused = true;
    if (focused) emailRef.current?.focus();
    return () => (focused = false);
  }, [emailRef]);

  useEffect(() => {
    if (loginDatas.pass?.length > 1) {
      setActive2("on");
    } else if (loginDatas.pass?.length === 0) {
      setErrorMsg({ ...errorMsg, msg2: "" });
      setActive2("default");
    }
    // eslint-disable-next-line
  }, [loginDatas.email, loginDatas.pass]);

  return (
    <>
      {/* <HeadCont rightIcon={"no icon"} /> */}
      <form onSubmit={onLogin} className="mx-6 mt-[80px] flex flex-col gap-6">
        {/* <TitleBox option={2} title={t('login.phone_login')} /> */}
        {/* 디자인상 3번째, 8번째 자리에 띄어쓰기를 해야하기 때문에 type='number' 대신 'text'로 진행 */}
        <InputBox
          option={"label"}
          placeholder={t('login.email_placeholder')}
          inputM={"email"}
          refName={emailRef}
          id={"email"}
          nameTitle={"email"}
          onChangeAction={(e) => onChangeInput1(e)}
          value={loginDatas.email || ""}
          active={active1}
          onClickAction={() => onDeleteValue("email")}
          errorMsg={errorMsg.msg1}
          login={true}
        />
        <InputBox
          option={"passlabel"}
          // label={t('login.password')}
          placeholder={t('login.password_placeholder')}
          refName={passRef}
          id={"pass"}
          nameTitle={"pass"}
          length={4}
          onChangeAction={(e) => onChangeInput2(e)}
          value={loginDatas.pass || ""}
          active={active2}
          onClickAction={() => onDeleteValue("pass")}
          errorMsg={errorMsg.msg2}
        />

        {/* 디자인대로 로그인 버튼 바로 위에 fixed 위치했다가 갤럭시에서 flot되어 비밀번호 위에 올라가는 현상으로 디자인 변경 */}
        {/* <div className="space-y-2 text-center">
          <p className="text-sm font-light">{t('login.login_issues')}</p>
          <ul className="flex justify-center text-lg font-bold text-gray_160">
            <li onClick={() => navigate(`/findpass`)}>{t('login.find_password')}</li>
            <span className="mx-2 my-1 w-[1px] bg-gray_60"></span>
            <li onClick={() => navigate(`/sign`)}>{t('login.other_login_methods')}</li>
          </ul>
        </div> */}
        <Btn
          bgColor={"bg-main"}
          textColor={"text-white font-semibold text-lg"}
          borderColor={"border border-main"}
          title={t('login.login_button')}
          onAction={onLogin}
          // active={active1 === "on" && active2 === "on" ? "on" : "ready"}
          active={"on"}
        />
      </form>
      {openDialog && (
        <Dialog
          innerClass={"py-4 pl-6 pr-5"}
          btnClass={"mt-8"}
          title={t('login.success')}
          desc={t('login.welcome_back', { name: loginInfo.nickName }) + '💕'}
          onRightBtnAction={() => navigate(`/home`)}
          onCoverAction={() => navigate(`/home`)}
        />
      )}
    </>
  );
};

export default SignIn;
